import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { OrdersDistributionChart } from './components/OrderDistributionChart';
import { TableTotals } from './components/TableTotals';
import { CardCount } from './components/CardCount';
import { FiAlertTriangle, FiCheckCircle, FiClock, FiFileMinus, FiFileText, FiMinusCircle, FiTool } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import { loadPerformanceEmp } from '../../../../../app/store/reportes/thunks';
import { startloadSaleReport } from '../../../../../app/store/sales/thunks';
import { startloadOrden } from '../../../../../app/store/ordenes/thunks';
import { AlertTriangle, FilePlus, Search } from 'react-feather';

export const Rendimiento = () => {


    const COLORS = {
        ORDENES_SIN_ASIGNAR: "#ffc107",
        ORDENES_EN_PROCESO: "#17a2b8",
        ORDENES_ENTREGADAS: "#2ECC71",
        ORDENES_CANCELADAS: "#dc3545",
        EQUIPO_RETIRADO: "#100f11",
    };

    const dispatch = useDispatch();


    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    const { empleados } = useSelector(state => state.empleados);
    const { isLoading, status_report, performanceEmployee, performanceTotalesEmployee, grantotalPerformance } = useSelector(state => state.reportes);
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;


    const searchData = (data) => {
        dispatch(loadPerformanceEmp(data.fechaInicial, data.fechaFinal, data.tecnico))
    }

    const loadFolio = (folio) => {
        if (folio.includes("HDLV")) {
            dispatch(startloadSaleReport(folio))
        } else {
            dispatch(startloadOrden(folio));
        }
    }


    const data = performanceTotalesEmployee[0];


    // console.log(data);


    let dataTable = [...performanceEmployee];

    let columns = [
        {
            header: 'FOLIO',
            dataIndex: 'FOLIO',
            classHeader: 'text-start',
            classRow: 'text-start',
            isTotal: false, // 👈 sumará esta columna
            renderer: (value) => (
                <>
                    <button type="button" className="btn btn-link" data-bs-toggle="modal" data-bs-target="#detailFolio" onClick={() => loadFolio(value)}>{value}</button>
                </>
            ),
        },
         {
            header: 'REGISTRO',
            dataIndex: 'FECHA_REGISTRO',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'ASIGNACION',
            dataIndex: 'FECHA_ASIGNACION',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'COMPLETA',
            dataIndex: 'FECHA_COMPLETADA',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'ENTREGADA',
            dataIndex: 'FECHA_CERRADA',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: false, // 👈 sumará esta columna
        },
        {
            header: 'DIAGNOSTICOS',
            dataIndex: 'DIAGNOSTICOS_REGISTRADOS',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: true, // 👈 sumará esta columna
        },
        {
            header: 'DIAG. EXTRAS',
            dataIndex: 'DIAGNOSTICOS_EXTRAS',
            classHeader: 'text-center',
            classRow: 'text-center',
            isTotal: true, // 👈 sumará esta columna
        },
        {
            header: 'ESTADO',
            dataIndex: 'ESTADO',
            classHeader: 'text-center',
            classRow: 'text-center',

            isTotal: false,
            renderer: (value) => {
                const estados = {
                    0: { label: 'Sin asignar', color: COLORS.ORDENES_SIN_ASIGNAR },
                    1: { label: 'En proceso', color: COLORS.ORDENES_EN_PROCESO },
                    2: { label: 'En proceso', color: COLORS.ORDENES_EN_PROCESO },
                    3: { label: 'En proceso', color: COLORS.ORDENES_EN_PROCESO },
                    4: { label: 'En proceso', color: COLORS.ORDENES_EN_PROCESO },
                    7: { label: 'Entregada', color: COLORS.ORDENES_ENTREGADAS },
                    8: { label: 'Entregada', color: COLORS.ORDENES_ENTREGADAS },
                    9: { label: 'Cancelada', color: COLORS.ORDENES_CANCELADAS },
                    10: { label: 'Equipo retirado', color: COLORS.EQUIPO_RETIRADO },
                };

                const estado = estados[value] || {
                    label: '',
                    color: ''
                };

                return (
                    <span
                        className="badge"
                        style={{
                            backgroundColor: estado.color,
                            color: value === 0 ? '#212529' : '#fff',
                            padding: '6px 10px',
                            borderRadius: '12px',
                            fontSize: '11px',
                            fontWeight: 600
                        }}
                    >
                        {estado.label}
                    </span>
                );
            }
        },
    ];

    return (
        <div className=''>



            <form className='row' onSubmit={handleSubmit(searchData)} >

                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-2'>
                    <label className="form-label">Tecnico:</label>

                    <select className="form-select " defaultValue={'0'}  {...register("tecnico")} >
                        <option value={'0'} >TODOS</option>
                        {
                            empleados.map((item, index) => (
                                item.ESTADO == 1 && item.ROL_ID == 3 ? <option key={index} value={item.ID} className='text-uppercase' >({item.USER}) | {item.NOMBRE} </option>
                                    : <option key={index} style={{ display: "none" }} ></option>
                            ))
                        }
                    </select>
                </div>

                <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <label className="form-label">Fecha de Inicio:</label>
                    <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                    {
                        errors.fechaInicial &&
                        <div className='text-left-5 mt-2'>
                            <AlertTriangle size="18" color="#dc3545" />
                            <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                        </div>
                    }
                </div>

                <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2  ">
                    <label className="form-label">Fecha de Termino:</label>
                    <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                </div>

                <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1">
                    <div className="mb-3 mt-4">
                        <button type="submit" className="btn btn-outline-dark ">
                            <Search size="20" /> Buscar
                        </button>
                    </div>
                </div>
            </form>


            <div className='row'>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="ORDENES" value={performanceTotalesEmployee[0]?.ORDENES_TOTALES || 0} icon={<FiTool size={24} className='text-white' />} bg_icon={'bg-primary'} />
                </div>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="P. ASIGNAR" value={performanceTotalesEmployee[0]?.ORDENES_SIN_ASIGNAR || 0} icon={<FiFileText size={24} className='text-white' />} bg_icon={'bg-warning'} />
                </div>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="PROCESO" value={performanceTotalesEmployee[0]?.ORDENES_EN_PROCESO || 0} icon={<FiClock size={24} className='text-white' />} bg_icon={'bg-info'} />
                </div>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="COMPLETOS" value={performanceTotalesEmployee[0]?.ORDENES_ENTREGADAS || 0} icon={<FiCheckCircle size={24} className='text-white' />} bg_icon={'bg-success'} />
                </div>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="CANCELADOS" value={performanceTotalesEmployee[0]?.ORDENES_CANCELADAS || 0} icon={<FiMinusCircle size={24} className='text-white' />} bg_icon={'bg-danger'} />
                </div>
                <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                    <CardCount title="RETIRADOS" value={performanceTotalesEmployee[0]?.EQUIPO_RETIRADO || 0} icon={<FiFileText size={24} className='text-white' />} bg_icon={'bg-dark'} />
                </div>
            </div>

            <div className='row'>
                <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="fw-bold mb-0">Listado de Ordenes</h4>
                            <div className="text-muted">
                                En el periodo indicado
                            </div>
                        </div>
                        <div className="card-body">
                            <TableTotals
                                columns={columns}
                                data={dataTable}
                                function_={(row) => {
                                    console.log(row);
                                }}
                                placeholderSearch="Buscar por: Folio, Fecha(s)"
                                showPagination={true}
                                showControls={true}
                                showTotals={true}
                                countRow={true} // 👈 activa el contador de filas
                                showAverage={false}  // 👈 activa fila de promedio
                                msg={'No hay datos por mostrar'}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <OrdersDistributionChart data={data} />
                </div>
            </div>
        </div>
    )
}
